import { func, object, string } from "prop-types";
import { Button } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { WarningOutlined } from "@ant-design/icons";
import styles from "./AddNewCampaign.module.css";
import CampaignDetails from "./CampaignDetails";
import { useCreateCampaignSteps } from "../../../api/campaignSteps";
import { useCreateCampaign } from "../../../api/campaigns";
import {
  generateCampaignDetails,
  gatherCampaignData,
  buildStepCreationRequest,
} from "../../../utils/campaignStepBuilder";

function SubmitStep({
  contractId,
  companyId,
  campaignState,
  allData,
  updateStep,
}) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const createCampaignSteps = useCreateCampaignSteps();
  const createCampaign = useCreateCampaign({ companyId, contractId });

  const createCampaignStep = async ({
    stepName,
    stepType,
    newlyCreatedEmailTemplates,
  }) => {
    const step = campaignState[stepName];
    const stepsCreationRequest = buildStepCreationRequest(
      step,
      stepType,
      newlyCreatedEmailTemplates
    );
    const [campaignStep] = await createCampaignSteps.mutateAsync(
      stepsCreationRequest
    );

    if (campaignStep.relations?.emailTemplates) {
      newlyCreatedEmailTemplates.push(
        ...campaignStep.relations?.emailTemplates
      );
    }
    return campaignStep;
  };

  const onSubmit = async () => {
    try {
      setLoading(true);
      setError("");
      const campaignData = await gatherCampaignData(
        campaignState,
        contractId,
        companyId,
        // Ideally we would also extract this logic into the gather, but there's a hook invoked within that is clunky to pass through
        createCampaignStep
      );
      await createCampaign.mutateAsync(campaignData);

      setLoading(false);

      history.push(`/contracts/${contractId}`);
    } catch (err) {
      setError(err.message || "An error occurred");
      setLoading(false);
    }
  };

  return (
    <div>
      {error && (
        <h4 className={styles.error}>
          <WarningOutlined fill="red" /> {error}
        </h4>
      )}
      <CampaignDetails
        data={generateCampaignDetails(campaignState, allData, updateStep)}
      />
      <div className={styles.createCampaignButtonContainer}>
        <Button loading={loading} type="primary" onClick={onSubmit}>
          Create Campaign
        </Button>
      </div>
    </div>
  );
}

SubmitStep.propTypes = {
  contractId: string,
  companyId: string,
  campaignState: object,
  allData: object,
  updateStep: func,
};

export default SubmitStep;
